import { z } from 'zod'
import { stringSchema } from './common'

export const currencySchema = z.object({
  code: stringSchema.toUpperCase().regex(/^[A-Z]{3}$/),
  name: stringSchema.min(1),
  sign: stringSchema.min(1),
  roundUp: z.number().default(1),
  signBefore: z.boolean().default(true),
  default: z.boolean().default(false),
})
